/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import * as yup from 'yup';
import { DatePicker, Drawer, message, Upload } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';
import {isEmpty, map} from 'lodash';

const safetyInfo = [
  {key: 'is_friendly', value: 'Yes, my dog is friendly.'},
  {key: 'can_clean_if_in_yard', value: 'Yes, you can clean with my dogs in the yard'},
  {key: 'can_treat', value: 'Yes, you can give my dog a treat.'},
  {key: 'has_doggy_door', value: 'Yes, there a doggy door'},
  {key: 'is_dogs_outside', value: 'Yes, Dogs are left outside when no one is home'},
];

class AddDog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      service_order_uuid: '',
      uuid: '',
      image: '',
      name: '',
      breed: '',
      birthday: '',
      is_friendly: false,
      can_treat: false,
      can_clean_if_in_yard: false,
      has_doggy_door: false,
      is_dogs_outside: false,
      is_btn_active: false,
      serviceOrder: {},
      is_dog_img: false,
      errors: {},
      additional_info:''
    }
    this.upload = null;
  }

	UNSAFE_componentWillReceiveProps = (nextProps) => {
	  // message.destroy()
	  this.setState({loader: false})
	  // set service order uuid
	  if (nextProps?.service_order_uuid) {
	    // this.setState({ service_order_uuid: nextProps?.service_order_uuid })
	  }

	  if (!nextProps.isEdit) {
	    this.onClear() // clear for add new dog detail
	  } else if (!isEmpty(nextProps?.dogInfo)) {
	    const {dogInfo} = nextProps;

	    // set dog information
	    this.setState({
	      uuid: dogInfo?.uuid,
	      image: dogInfo?.photo,
	      name: dogInfo?.name,
	      breed: dogInfo?.breed,
	      birthday: dogInfo?.birthday ? moment(dogInfo?.birthday).format('MM/DD/YYYY') : '',
	      is_friendly: dogInfo?.is_friendly,
	      can_treat: dogInfo?.can_treat,
	      has_doggy_door: dogInfo?.has_doggy_door,
	      is_dogs_outside: dogInfo?.is_dogs_outside,
	      can_clean_if_in_yard: dogInfo?.can_clean_if_in_yard,
	      service_order_uuid: dogInfo?.service_order_uuid ? dogInfo?.service_order_uuid : nextProps?.service_order_uuid,
	      additional_info: dogInfo?.additional_info
	    })
	  }

	  // get service order
	  if (Object.keys(nextProps?.serviceOrder).length > 0
			&& JSON.stringify(nextProps?.serviceOrder) !== JSON.stringify(this.state.serviceOrder)) {
	    this.setState(({serviceOrder: nextProps?.serviceOrder}))
	  }
	}

	// on dog detail change
	onTextChange = (e, type) => {
	  const value = type === 'bool' ? e.target.checked : e.target.value;
	  this.setState({ [e.target.name]: value })
	}

	// on birthday change
	onBirthdayChange = (e) => {
	  const value = e.target.value;
	  let new_value = value
	  if (value?.length === 2) {
	    new_value = value + '/'
	  } else if (value?.length === 5) {
	    new_value = value + '/'
	  }
	  this.setState({birthday: new_value})
	}

	// on birthday key press event
	onBirthdayKeyPress = (e) => {
	  let {birthday} = this.state;
	  const value = e.key;
	  if (value === "Backspace") {
	    if (birthday.substr(birthday?.length - 1, 1) === '/') {
	      e.preventDefault()
	    this.setState({birthday: birthday.substr(0, birthday?.length - 1)})
	    }
	  }
	}
	
	// get base 64 string
	getBase64String = (file = {}, cb) => {
	  const reader = new FileReader();
	  reader.readAsDataURL(file);
	  reader.onloadend = function () {
	    cb(reader.result)
	  }
	}

	// on user image change
	onImageChange = (e) => {
	  const file = e?.file ? e.file : e?.target?.files?.[0];
	  if (file?.size > (5 * 1048576)) {
	    message.error('Image size should be less than 5MB')
	  } else {
	    file && this.getBase64String(file, (result) => {
	      this.setState({ image: result, is_dog_img: true })
	    })
	  }
	}

	// on cancel
	onCancel = () => {
	  const { closeDrawer } = this.props;
	  closeDrawer();
	  this.onClear();
	}

	// on clear
	onClear = () => {
	  this.setState({
	    uuid: '',
	    image: '',
	    name: '',
	    breed: '',
	    birthday: '',
	    isFriendly: false,
	    isTreat: false,
	    service_order_uuid: '',
	    errors: {},
	    additional_info: '',
	    is_friendly: false,
	    can_clean_if_in_yard: false,
	    can_treat: false,
	    has_doggy_door: false,
	    is_dogs_outside: false,
	  })
	}

	// validate required fields
	validate = () => {
	  const { name, service_order_uuid, birthday, errors } = this.state;

	  const schema = yup.object().shape({
	    name: yup.string().required('Name is required'),
	    service_order_uuid: yup.string().required('Service address is required')
	  });

	  const data = { name, service_order_uuid }
	  schema.validate(data, { abortEarly: false }).then(() => {
	    this.setState({ is_btn_active: true, errors: {} });
	    if (birthday!=="" && (!moment(birthday).isValid() || !(moment(birthday) <= moment().endOf('day'))) ) {
	    	Object.assign(errors, {birthday: 'Invalid date'})
	    	this.setState({errors})
	    } else {
	      if (this.props.isEdit) this.onUpdate()
	      else this.onAdd()
	    }
	  }).catch((error) => {
	    let err_data = {};
	    map(error.inner, (item) => {err_data[item.path] = item.message})
	    this.setState({errors: err_data, is_btn_active: false})
	  })
	}

	// on add
	onAdd = () => {
	  const { closeDrawer, addPet, isProcessing } = this.props;
	  const { image, name, breed, birthday, is_friendly, can_treat, can_clean_if_in_yard, has_doggy_door, is_dogs_outside, service_order_uuid, is_dog_img, additional_info } = this.state;

	  isProcessing(true);
	  let obj = {
	    name,
	    breed,
	    birthday: birthday ? moment(birthday).format('YYYY-MM-DD') : null,
	    is_friendly,
	    can_treat,
	    can_clean_if_in_yard, 
	    has_doggy_door,
	    service_order_uuid,
	    additional_info
	  }

	  if (image && is_dog_img) {
	    obj = { ...obj, photo: image }
	  }

	  addPet(obj)
	  setTimeout(() => this.props.updatePartialServiceOrder({uuid: service_order_uuid, has_doggy_door, is_dogs_outside, can_clean_if_in_yard}), 500)
	  this.setState({is_dog_img: false})
	  closeDrawer();
	  this.onClear();
	}

	// on Update
	onUpdate = () => {
	  const { closeDrawer, updatePet, isProcessing } = this.props;
	  const { uuid, image, name, breed, birthday, is_friendly, can_treat, can_clean_if_in_yard, has_doggy_door, is_dogs_outside, service_order_uuid, is_dog_img, additional_info } = this.state;

	  isProcessing(true);
	  let obj = {
	    uuid,
	    name,
	    breed,
	    birthday: birthday ? moment(birthday).format('YYYY-MM-DD') : null,
	    is_friendly,
	    can_treat,
	    can_clean_if_in_yard, 
	    has_doggy_door,
	    service_order_uuid,
	    additional_info
	  }

	  if (image && is_dog_img) {
	    obj = { ...obj, photo: image }
	  }

	  this.setState({is_dog_img: false})
	  updatePet(obj);
	  setTimeout(() => this.props.updatePartialServiceOrder({uuid: service_order_uuid, has_doggy_door, is_dogs_outside, can_clean_if_in_yard}), 500)
	  closeDrawer();
	  this.onClear();
	  setTimeout(() => this.props.getPets(), 1000)
	};
	
	//render service address
	renderServiceOrder = () => {
	  let { serviceOrder, service_order_uuid } = this.state;
	  return map(serviceOrder?.results, (item, i) => {
	    if (item?.billing_address) {
	      return (
	        <div className="fitem-check" key={i}>
	          <input
	            type="radio" name="address"
	            checked={service_order_uuid === item?.uuid}
	            id={`address${i}`}
	            className="fitem-ck-input"
	            onChange={() => this.onTextChange({ target: { name: 'service_order_uuid', value: item?.uuid } })}
	          />
	          <label htmlFor={`address${i}`} className="fitem-ck-txt">
	            {item.billing_address ?
							`${item.billing_address.address}, ${item.billing_address.city}, ${item.billing_address.state}, ${item.billing_address.zip_code} ` : ''}
	          </label>
	        </div>
	      )
	    }
	  })
	}

	render() {
	  const { visible, closeDrawer, isEdit } = this.props;
	  const { name, breed, birthday, image, additional_info, errors } = this.state;
	  return (
	    <Drawer
	      placement={'right'}
	      closable={false}
	      onClose={closeDrawer}
	      visible={visible}
	      key={'right'}
	      width={'400'}
	      className="drawer-wrapper"
	    >
	      <div className="filter_drawer_wrapper rdrawer dogs-bar">
	        <div className="card-head flex">
	          <h4>
	            {isEdit ? <i className="las la-pen"></i> : <i className="las la-plus-circle"></i>}
	            {isEdit ? ' Edit Dog' : ' Add Dog'}
	          </h4>
	          <CloseOutlined onClick={closeDrawer} />
	        </div>
	        <div className="card-row flex-column">
	          <div className="card-full">
	            <div className="file_upload_section flex ai-center flex-start">
	              <input
	                name={"image"}
	                type="file"
	                ref={(ref) => this.upload = ref}
	                style={{ "display": "none" }}
	                onChange={(e) => this.onImageChange(e)}
	              />
	              {
	                image ?
	                  <div className="uploded_img">
	                    <img src={image} alt="" className="user_img" onClick={() => this.upload?.click()} />
	                  </div>
	                  :
	                  <Upload
	                    name="avatar"
	                    listType="picture-card"
	                    className="avatar-uploader"
	                    showUploadList={false}
	                    beforeUpload={() => false}
	                    onChange={(e) => { this.onImageChange(e) }}>

	                    <div className="upload_text">
	                      <i className="las la-plus-circle"></i>
	                      <p>Upload Photo Optional</p>
	                    </div>
	                  </Upload>
	              }
	            </div>
	            <div className="form-group">
	              <div className="fitem">
	                <label htmlFor="name">Dog Name</label>
	                <input
	                  name="name"
	                  type="text"
	                  placeholder={'Dog Name'}
	                  value={name}
	                  onChange={(e) => this.onTextChange(e)}
	                />
	                {errors?.['name'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['name']}</label> : ''}
	              </div>
	              <div className="fitem">
	                <label htmlFor="breed">Dog Breed</label>
	                <input
	                  name="breed"
	                  type="text"
	                  placeholder={'Dog Breed'}
	                  value={breed}
	                  onChange={(e) => this.onTextChange(e)}
	                />
	              </div>
	              <div className="fitem">
	                <label htmlFor="birthday">Birthday</label>
	                <div className={'flex pos-relative'}>
	                  <input type={'text'} placeholder={'MM/DD/YYYY'}
	                    maxLength={10} value={birthday || ''}
	                    onChange={(e) => this.onBirthdayChange(e)}
	                    onKeyDown={(e) => this.onBirthdayKeyPress(e)}/>
	                  <div className={"only-icon-datepick"}>
	                    <DatePicker
	                      ref={(e) => this.datePicker = e}
	                      disabledDate={(current) => {
	                        return current && current > moment().endOf("day");
	                      }}
	                      id={'birthday'}
	                      name='birthday'
	                      className="swhite summry_date_picker flex-end"
	                      inputReadOnly
	                      allowClear={false}
	                      placeholder={'MM/DD/YYYY'}
	                      format={'MM/DD/YYYY'}
	                      value={(birthday && !isNaN(moment(birthday, 'MM/DD/YYYY'))) ? moment(birthday, 'MM/DD/YYYY') : null}
	                      onChange={(e) => this.onTextChange({ target: { name: 'birthday', value: moment(e).format('MM/DD/YYYY') } })} />
	                  </div>
	                </div>
	                {errors?.['birthday'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['birthday']}</label> : ''}
	              </div>
	            </div>
	            <div className="fitem">
	              <span>Service Address</span>
	              {this.renderServiceOrder()}
	              {errors?.['service_order_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['service_order_uuid']}</label> : ''}
	            </div>
	          </div>
	          <div className="card-full pl-0 pr-0 pt-0">
	            <hr/>
	            <div className="inline-check-list gcheck">
	              <strong className="mb-10 d-block">Dog Information</strong>
	              {map(safetyInfo, obj => {
	                return (
	                  <div className="fitem-check">
	                    <input
	                      type="checkbox"
	                      className="fitem-ck-input"
	                      id={obj.key}
	                      name={obj.key}
	                      checked={this.state[obj.key]}
	                      onChange={(e) => this.onTextChange(e, 'bool')} />
	                    <label htmlFor={obj.key} className="fitem-ck-txt">{obj.value}</label>
	                  </div>
	                )
	              })}
	            </div>
	            <hr/>
	            <div className="card-full pl-0 pr-0 pt-0">
	              <div className="inline-check-list gcheck">
	                <strong className="mb-10 d-block">Additional Information</strong>
	                <div className="fitem">
	                  <input
	                    name="additional_info"
	                    type="text"
	                    placeholder={'Additional Information'}
	                    value={additional_info}
	                    onChange={(e) => this.onTextChange(e)}
	                  />
	                </div>
	              </div>
						
	            </div>
	          </div>
					

	          <div className="footer">
	            <button className={`btn btn-brand btn-bdr`} onClick={() => this.onCancel()}>Cancel</button>
	            <button
	              // type="submit"
	              className={`btn btn-warning`}
	              // disabled={!is_btn_active}
	              onClick={() => this.validate()}>
	              {isEdit ? 'Update Dog' : 'Add Dog'}
	            </button>
	          </div>
	        </div>
	      </div>
	    </Drawer>
	  );
	}
}

export default AddDog;
